module.exports = __webpack_public_path__ + "img/emoji_43.f12279c0.png";